import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Terms of Service | IntelliEats';
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-655">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-656">
        <header className="mb-12" data-id="element-657">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-658">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-659" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-660">
            <div className="bg-accent-100 text-accent-600 p-3 rounded-2xl" data-id="element-661">
              <FileText className="w-8 h-8" data-id="element-662" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-663">
              Terms of Service
            </h1>
          </div>
          <p className="text-slate-500 text-sm" data-id="element-664">Last updated: April 7, 2025</p>
        </header>

        <div className="space-y-10 text-slate-700 leading-relaxed" data-id="element-665">
          <section data-id="element-666">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-667">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-668">
              By downloading, installing, or using the IntelliEats mobile
              application ("App"), you agree to be bound by these Terms of
              Service ("Terms"). If you do not agree to these Terms, please do
              not use the App.
            </p>
          </section>

          <section data-id="element-669">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-670">
              2. Description of Service
            </h2>
            <p data-id="element-671">
              IntelliEats is a mobile application that uses AI technology to
              scan and analyze ingredient labels on packaged food products. The
              App categorizes ingredients into "Safe," "Limited Intake," and
              "Ingredients to Avoid" based on available nutritional research and
              databases.
            </p>
          </section>

          <section data-id="element-672">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-673">
              3. Disclaimer
            </h2>
            <div className="bg-accent-50 rounded-2xl p-6 border border-accent-100" data-id="element-674">
              <p className="m-0 font-medium text-slate-800" data-id="element-675">
                <strong data-id="element-676">Important:</strong> IntelliEats is designed for
                informational purposes only and should not be considered medical
                or nutritional advice. The ingredient analysis provided by the
                App is based on general nutritional guidelines and may not
                account for individual health conditions, allergies, or dietary
                needs. Always consult with a qualified healthcare professional
                before making significant dietary changes.
              </p>
            </div>
          </section>

          <section data-id="element-677">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-678">
              4. User Responsibilities
            </h2>
            <ul className="space-y-3 list-none p-0" data-id="element-679">
              <li className="flex items-start gap-3" data-id="element-680">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-681"></span>
                <span data-id="element-682">
                  You are responsible for ensuring the accuracy of scanned
                  images and labels
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-683">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-684"></span>
                <span data-id="element-685">
                  You agree not to use the App for any unlawful purpose
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-686">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-687"></span>
                <span data-id="element-688">
                  You acknowledge that scan results depend on image quality and
                  label clarity
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-689">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-690"></span>
                <span data-id="element-691">
                  You agree not to reverse engineer, decompile, or disassemble
                  the App
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-692">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-693">
              5. Intellectual Property
            </h2>
            <p data-id="element-694">
              All content, features, and functionality of the App—including but
              not limited to text, graphics, logos, icons, and software—are the
              exclusive property of IntelliEats and are protected by
              international copyright, trademark, and other intellectual
              property laws.
            </p>
          </section>

          <section data-id="element-695">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-696">
              6. Limitation of Liability
            </h2>
            <p data-id="element-697">
              To the fullest extent permitted by applicable law, IntelliEats and
              its developer shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages arising out of or
              related to your use of the App. This includes, but is not limited
              to, any health-related decisions made based on the App's analysis.
            </p>
          </section>

          <section data-id="element-698">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-699">
              7. Pricing
            </h2>
            <p data-id="element-700">
              The ingredient scanning feature of IntelliEats is free to use.
              Customization features may be available at a minimum cost. We
              reserve the right to modify pricing with reasonable notice to
              users.
            </p>
          </section>

          <section data-id="element-701">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-702">
              8. Termination
            </h2>
            <p data-id="element-703">
              We reserve the right to terminate or suspend your access to the
              App at any time, without prior notice, for conduct that we believe
              violates these Terms or is harmful to other users, us, or third
              parties.
            </p>
          </section>

          <section data-id="element-704">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-705">
              9. Changes to Terms
            </h2>
            <p data-id="element-706">
              We reserve the right to modify these Terms at any time. Continued
              use of the App after changes constitutes acceptance of the revised
              Terms.
            </p>
          </section>

          <section className="bg-brand-50 rounded-2xl p-8 border border-brand-100" data-id="element-707">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-708">
              10. Contact Us
            </h2>
            <p className="mb-4" data-id="element-709">
              If you have any questions about these Terms, please contact us:
            </p>
            <p className="font-medium text-slate-900" data-id="element-710">
              Email:{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 transition-colors" data-id="element-711">
                intellieats@gmail.com
              </a>
            </p>
            <p className="mt-2" data-id="element-712">
              Or use our{' '}
              <Link to="/contact" className="text-brand-600 hover:text-brand-700 font-medium transition-colors" data-id="element-713">
                Contact Support
              </Link>{' '}
              page.
            </p>
          </section>
        </div>
      </div>
    </motion.div>;
}